/**
 * Returns true if the string is non-empty after trim and is not an empty TipTap/paragraph tag.
 * Use when validating rich-text content (e.g. from TipTap/Editor.js) that may be empty or `<p></p>`.
 */
export function isTiptapTextValid(text: string): boolean {
	return typeof text === 'string' && text.trim() !== '' && text.trim() !== '<p></p>'
}
